<template>
  <div>
    <RouterView />
  </div>
</template>

<script>
</script>